import { CheckMarkOutlineIcon, ClockOutlineIcon, CloseOutlineIcon, } from '@applyboard/ui-icons'

import { ApplicationDetailsIntent } from '../types'

export function getIcon(intent: ApplicationDetailsIntent, activeRecord?: boolean) {
  if (activeRecord === false) {
    return CloseOutlineIcon
  } else {
    switch (intent) {
      case 'positive':
        return CheckMarkOutlineIcon
      case 'negative':
        return CloseOutlineIcon
      default:
        return ClockOutlineIcon
    }
  }
  
}
